import '~/styles/application.css';

// iOS Safari ignores viewport user-scalable=no for pinch zoom — block gesture events.
for (const event of ['gesturestart', 'gesturechange', 'gestureend']) {
  document.addEventListener(event, (e) => e.preventDefault(), { passive: false });
}

import { createApp, h } from 'vue';

import { createInertiaApp } from '@inertiajs/vue3';

import * as Routes from '@/routes.js';
import { translationsPlugin } from '@/utils/translations.js';

const pages = import.meta.glob('../Pages/**/*.vue', { eager: true });

createInertiaApp({
  resolve: (name) => {
    const component = pages[`../Pages/${name}.vue`];
    if (!component)
      throw new Error(
        `Unknown page ${name}. Is it located under Pages with a .vue extension?`,
      );

    return component;
  },

  title: (title) =>
    title ? `${title} - CMS CODE - Łódź` : 'CMS CODE - Łódź',

  setup({ el, App, props, plugin }) {
    const vueApp = createApp({
      render: () => h(App, props),
    });
    vueApp.config.globalProperties.$routes = Routes;
    vueApp.use(plugin).use(translationsPlugin).mount(el);
  },
});
